<template>
  <div class="clearfix">
    <a-upload
      :class="inputClass"
      ref="uploadBtn"
      :accept="acceptType"
      :fileList="fileArray"
      :listType="listType"
      :remove="handleRemove"
      :beforeUpload="beforeUpload"
      :customRequest="myUploadReauest"
      @preview="handlePreview"
      :disabled="disabled"
    >
      <div
        v-if="listType == 'picture-card' && fileArray.length < limitNum"
        :style="`width:${width}px`"
      >
        <a-icon :type="isUploading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">{{ text }}</div>
      </div>
      <a-button v-else-if="fileArray.length < limitNum">
        <a-icon :type="isUploading ? 'loading' : 'upload'" />选择文件
      </a-button>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal
      title="图片裁剪"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="confirmUpload"
      @cancel="handleOk"
      okText="确认"
      cancelText="取消"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center;" :style="{ height: autoCropHeight + 'px' }">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="autoCropWidth"
            :autoCropHeight="autoCropHeight"
            :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { converBToMb, transformUrl } from '@/utils/util'
import { VueCropper } from 'vue-cropper'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'Upload',
  components: {
    VueCropper
  },
  data() {
    return {
      isUploading: false,
      commonFolder: process.env.VUE_APP_OBS_FOLDER_NAME,
      filePath: '',
      fileArray: [],
      previewVisible: false,
      previewImage: '',
      imageType: ['png', 'jpeg', 'jpg', 'bmp', 'gif'],
      visible: false,
      confirmLoading: false,
      fielName: '',
      uid: '',
      option: {
        img: '',
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        full: true, // 是否输出原图比例的截图
        canMove: true, // 时候可以移动原图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    inputClass: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'text'
    },
    accept: {
      type: String,
      default: ''
    },
    limitNum: {
      type: Number,
      default: 9
    },
    autoCropWidth: {
      type: Number,
      default: 400
    },
    autoCropHeight: {
      type: Number,
      default: 300
    },
    singleSize: {
      type: Number,
      default: 10 * 1024
    },
    isRename: {
      type: Boolean,
      default: true
    },
    path: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 86
    },
    text: {
      type: String,
      default: '图片上传'
    }
  },
  computed: {
    acceptType() {
      if (this.accept) {
        return this.accept
      } else if (this.listType === 'picture' || this.listType === 'picture-card') {
        return 'image/*'
      } else {
        return ''
      }
    }
  },
  watch: {
    fileList: {
      handler(newValue, oldValue) {
        let index = 0
        this.fileArray = []
        for (const url of newValue) {
          const arr = url.split('/')
          const fileName = arr[arr.length - 1]
          this.fileArray.push({
            uid: new Date().getTime() + '-' + index++,
            size: 0,
            name: fileName,
            status: 'done',
            type: 'Undeletable',
            url: transformUrl(url),
            relativeUrl: url
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    uploadClick() {
      console.log('uploadClick')
      document.querySelector('.' + this.inputClass + ' input').click()
    },
    async handleRemove(file) {
      const _self = this
      const index = _self.fileArray.indexOf(file)
      const newFileList = _self.fileArray.slice()
      newFileList.splice(index, 1)
      _self.fileArray = newFileList
      _self.changeSuccees()
      // const obsClient = await this.authObsClient()
      // const removeUrl = file.relativeUrl
      // obsClient.deleteObject(
      //   {
      //     Bucket: process.env.VUE_APP_OBS_BUCKET,
      //     Key: removeUrl
      //   },
      //   function(err, result) {
      //     if (err) {
      //       console.log('delete Error-->' + err)
      //     } else {
      //       const index = _self.fileArray.indexOf(file)
      //       const newFileList = _self.fileArray.slice()
      //       newFileList.splice(index, 1)
      //       _self.fileArray = newFileList
      //       _self.changeSuccees()
      //     }
      //   }
      // )
    },
    beforeUpload(file, fileList) {
      this.isUploading = true
      if (this.singleSize) {
        const limitFileSize = this.singleSize * 1024
        if (file.size > limitFileSize) {
          this.$notification['error']({
            message: '文件需小于' + converBToMb(this.singleSize) + ', 您上传的文件大小为:' + converBToMb(file.size)
          })
          return false
        }
      }
      return true
    },
    async myUploadReauest(item, type) {
      console.log('item', item)
      this.item = item
      let prePath = this.path

      if (prePath) {
        if (!prePath.startsWith('/')) prePath = '/' + prePath
        if (!prePath.endsWith('/')) prePath = prePath + '/'
      } else {
        prePath = '/'
      }
      if (type) {
        prePath = '/img/art/'
      }
      this.filePath = this.commonFolder + prePath
      item.file.status = 'uploading'
      const _self = this
      const obsClient = await this.authObsClient()
      let fileName = item.file.name
      this.fielName = item.file.name
      if (this.isRename) {
        fileName = item.file.uid
        if (item.file && item.file.name && item.file.name.indexOf('.') >= 0) {
          const splitNames = item.file.name.split('.')
          fileName = fileName + '.' + splitNames[splitNames.length - 1]
        }
      }
      const key = this.filePath + fileName
      const relativeUrl = prePath + fileName
      obsClient.putObject(
        {
          Bucket: process.env.VUE_APP_OBS_BUCKET,
          Key: key,
          SourceFile: item.file
        },
        function(error, res) {
          _self.isUploading = false
          if (!type) {
            _self.option.img = transformUrl(relativeUrl)
            console.log('_self.option.img', _self.option.img)
            _self.visible = true
            console.log('relativeUrl', relativeUrl)
          } else {
            console.log('relativeUrl', relativeUrl)
            _self.putFileToList(item, relativeUrl, error ? 'error' : 'success')
          }
        }
      )
    },
    putFileToList(item, relativeUrl, status) {
      const _self = this
      const original = item.file.uid + '.' + item.file.name.split('.')[1]
      const title = original
      item.file.status = 'done'
      item.file.response = {
        status: status
      }
      if (!relativeUrl.startsWith('/')) {
        relativeUrl = '/' + relativeUrl
      }
      const fileTemp = {
        uid: item.file.uid,
        name: item.file.name,
        status: 'done',
        url: transformUrl(relativeUrl),
        relativeUrl: relativeUrl
      }
      _self.fileArray.push(fileTemp)
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      this.visible = false
      this.changeSuccees()
      if (item.file.response === 'error') {
        reader.onload = function(e) {
          item.onError({
            original: original,
            state: 'ERROR',
            status: 'error',
            title: title,
            url: transformUrl(relativeUrl)
          })
        }
      } else {
        item.onSuccess({
          original: original,
          state: 'SUCCESS',
          status: 'success',
          title: title,
          url: transformUrl(relativeUrl)
        })
      }
    },
    changeSuccees() {
      const files = this.getRelativeArray()
      console.log('files', files)
      this.$emit('uploadChange', files)
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      const extend = file.name.indexOf('.') > -1 ? file.name.split('.')[1] : ''
      if (this.imageType.indexOf(extend.toLowerCase()) > -1) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.previewImage = file.url || file.preview
        this.previewVisible = true
      }
    },
    getRelativeArray() {
      let relativeUrls = []
      this.fileArray.forEach(element => {
        relativeUrls = [...relativeUrls, element.relativeUrl]
      })
      return relativeUrls
    },
    async authObsClient() {
      const result = await this.$http.get(`/oss/oss/sts`)
      if (result.access) {
        const sts = result
        const obsClient = new ObsClient({
          access_key_id: sts.access,
          secret_access_key: sts.secret,
          server: process.env.VUE_APP_OBS_ENDPOINT
        })
        obsClient.util.securityToken = sts.securitytoken
        return obsClient
      } else {
        this.$notification['error']({
          message: '上传初始化失败，请刷新页面重试'
        })
      }
    },
    showModal() {
      this.visible = true
    },
    handleOk(e) {
      this.visible = false
    },
    confirmUpload() {
      const that = this
      this.$refs.cropper.getCropBlob(data => {
        // const file = that.dataURLtoFile(data)
        console.log('file', data)
        const fileDetail = {
          file: data
        }
        fileDetail.file.name = this.fielName
        fileDetail.file.uid = new Date().getTime()
        that.myUploadReauest(fileDetail, 1)
      })
    },
    dataURLtoFile(dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      console.log('mime', mime)
      const bstr = atob(arr[1])
      const n = bstr.length
      const u8arr = new Uint8Array(n)
      this.fielName = this.fielName.replace('.jpg', '.png')
      return new File([u8arr], this.fielName, { type: mime })
    }
  }
}
</script>
<style lang="less" scoped>
@import 'index';
.cropper-content {
  .cropper {
    width: auto;
  }
}
</style>
